import { downloadProjectAnnex } from "@/api/dilivery/sales/contract";
import { downloadProjectAttachment } from "@/api/dilivery/audit";
import { getDataInLocalStorage } from "@/utils/localStorage";

const baseURL = process.env.VUE_APP_BASE_API;

/**
 * 项目附件公共方法混入 - 供详情展示和变更对比组件共用
 * 提供：项目附件判断、查找、下载（原合同/变更后）、预览
 */
export default {
  methods: {
    findProjectAnnexProject(data) {
      if (!data || !Array.isArray(data.specificProjectType)) return null;
      return data.specificProjectType.find(p => p.annexFilePath && p.projectMainTypeId) || null;
    },
    // ========== 原合同项目附件（/sequencing-contract/project-annex/） ==========
    async downloadProjectAnnexFile(contractId, projectMainTypeId) {
      try {
        const url = `${baseURL}/sequencing-contract/project-annex/${contractId}/${projectMainTypeId}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`;
        const elink = document.createElement('a');
        elink.href = url;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    async previewProjectAnnexFile(contractId, projectMainTypeId) {
      try {
        const response = await downloadProjectAnnex(contractId, projectMainTypeId);
        if (response) {
          this.fileInfo = response;
          this.showFile = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // ========== 变更后项目附件（/audit-info/project-annex/） ==========
    async downloadProjectAttachmentFile(auditInfoId, projectMainTypeId) {
      try {
        const url = `${baseURL}/audit-info/project-annex/${auditInfoId}/${projectMainTypeId}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`;
        const elink = document.createElement('a');
        elink.href = url;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    async previewProjectAttachmentFile(auditInfoId, projectMainTypeId) {
      try {
        const response = await downloadProjectAttachment(auditInfoId, projectMainTypeId);
        if (response) {
          this.fileInfo = response;
          this.showFile = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
  }
};
